import { Component, Input } from '@angular/core';
import { DataTableColumnIcon } from './data-table-column-icon.config';

@Component({
  selector: 'data-table-column-icon',
  imports: [],
  templateUrl: './data-table-column-icon.component.html',
  styleUrl: './data-table-column-icon.component.scss'
})
export class DataTableColumnIconComponent {
  @Input() column!: DataTableColumnIcon;
  @Input() item!: any;

  getIconClass(): string {
    if (this.column?.value) {
      return this.column.value(this.item);
    }
    switch (this.item?.source) {
      case 'MAIL':
        return 'fa fa-at';
      case 'PHONE_CALL':
        return 'fa fa-phone';
      case 'SYSTEM':
        return 'fa fa-globe';
      default:
        return 'fa fa-globe';
    }
  }
}
